import { Badge, Button, ButtonProps, Icon, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export interface DeleteButtonProps extends ButtonProps {
  productsCount: number
}

export const DeleteProductsButton = ({ productsCount, onClick, ...rest }: DeleteButtonProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Button color="danger" variant="outlined" onClick={onClick} {...rest}>
      <Icon icon="trash" color="currentColor" />
      <Space size="s8" horizontal />
      <Text weight="bold" inherit>
        {t('products.table.actions.delete_selected')}
      </Text>
      <Space size="s8" horizontal />
      <Badge color="danger" mode="subtle">
        {productsCount}
      </Badge>
    </Button>
  )
}
